import type { Participant } from '../api/types'

/** Human-readable label for a participant row (mock uses invite:email keys). */
export function participantDisplayName(p: Participant): string {
  if (p.user_id.startsWith('invite:')) return p.user_id.slice('invite:'.length)
  return p.user_id
}
